import BottomBar from 'components/AugmentedReality/Instructions/BottomBar'
import {
  SCInstructionBackgroundPortrait,
  SCInstructionContainer,
} from 'components/AugmentedReality/Instructions/styled'
import SlideDots from 'components/AugmentedReality/Structure/SlideDots'
import TopBar from 'components/AugmentedReality/Structure/TopBar'
import { useState } from 'react'
import { AugmentedRealityType } from '../../../types/augmentedReality'
import { useSwipe } from '../hooks/useSwipe'

interface InstructionsFrameProps {
  ra: AugmentedRealityType;
  onNext: () => void;
  useCamera: boolean;
  onUseCamera: (state: boolean) => void;
  onPrevious: () => void;
  onCancel: () => void;
}
const InstructionsFrame = ({ ra, useCamera, onUseCamera, onNext, onPrevious, onCancel }: InstructionsFrameProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const handleNext = () => {
    if (currentSlide < ra.instructions.length - 1) {
      setCurrentSlide((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide((prev) => prev - 1);
    }
  };

  const {  onTouchStart,
  onTouchEnd} = useSwipe({
    onSwipeLeft: handleNext,
    onSwipeRight: handlePrev,
    isDisabled: isModalOpen,
  });


  return (
    <SCInstructionContainer
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <SCInstructionBackgroundPortrait $background={ra.instructions[currentSlide].image} />
      <TopBar label={ra.instructions[currentSlide].text} />

      <SlideDots count={ra.instructions.length} currentIndex={currentSlide} onChangeSlide={setCurrentSlide} />

      <BottomBar
        ra={ra}
        useCamera={useCamera}
        onUseCamera={onUseCamera}
        onNext={onNext}
        onPrevious={onPrevious}
        onCancel={onCancel}
        modalOpen={setIsModalOpen}
      />
    </SCInstructionContainer>
  )
}

export default InstructionsFrame